import { useEffect, useMemo, useState } from "react";
import "./OwnerDashboard.css";
import OwnerAddUserModal from "./OwnerAddUserModal.js";
import { StatsGrid } from "../components/upgraded/StatsWidget";
import { buildAnalyticsStats } from "../components/upgraded/analyticsStats";
// 1. Import the new modal
import OwnerAddAdminModal from "./OwnerAddAdmin.js";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const ITEMS_PER_PAGE = 10;

const tabs = [
  { key: "users", label: "Users" },
   { key: "students", label: "Students" },
  { key: "consultants", label: "Consultant Bookings" },
  { key: "orders", label: "Orders" },
  { key: "mindmap", label: "Mind Mapping" },
  { key: "ideaValidation", label: "Idea Validation Reports" },
  { key: "history", label: "History" }
];
const adminTab = { key: "admin", label: "Admin Info" };


export default function OwnerDashboard() {
  const [activeTab, setActiveTab] = useState("users");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [analytics, setAnalytics] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);

  /* ============ Analytics (StatsGrid) ============ */
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await fetch(`${BASE_URL}/owner/analytics`, { credentials: "include" });
        const json = await res.json();
        if (active && json?.success) setAnalytics(json.data);
      } catch (err) {
        console.error("Owner analytics error:", err);
      } finally {
        if (active) setStatsLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const statCards = useMemo(() => buildAnalyticsStats(analytics), [analytics]);
  // 2. Add state inside AdminDashboard function
const [showAddAdminModal, setShowAddAdminModal] = useState(false);
const [historySummary, setHistorySummary] = useState([]);
const [historyDetails, setHistoryDetails] = useState([]);
const [selectedHistoryUser, setSelectedHistoryUser] = useState(null);
const [historyRoleFilter, setHistoryRoleFilter] = useState("users"); // users | students
const [historyUserSearch, setHistoryUserSearch] = useState("");
const [historyDateFilter, setHistoryDateFilter] = useState("24h"); 
// 24h | week | month

const [historyYearFilter, setHistoryYearFilter] = useState(""); 
// "1" = last year, "2" = last 2 years, etc
const [showSuggestions, setShowSuggestions] = useState(false);




 /*below code is to get all history of users do not remove without asking*/

const fetchHistoryDetails = async (userId, role) => {
  try {
    const res = await fetch(
      `${BASE_URL}/Owner/search-history/details?userId=${userId}&role=${role}`
    );
    const json = await res.json();
    

    setHistoryDetails(json.data || []);
  } catch (err) {
    console.error("❌ History details fetch error", err);
  }
};

/*below code is to get  history of products not available in  site do not remove without asking

const fetchHistoryDetails = async (userId, role) => {
  try {
    const res = await fetch(
        `${BASE_URL}/Owner/search-history/details?userId=${userId}&role=${role}`
    );
    const json = await res.json();
    const rawData = json.data || [];

    // 1. Prepare the Sample Product names (normalized to lowercase)
    const sampleProductNames = new Set(
        SampleProducts.map(s => s.name.toLowerCase())
    );

    // 2. Filter out both Product Names and URLs
    const filteredSearches = rawData.filter((item) => {
      const term = (item.search_term || "").trim().toLowerCase();
      
      // Keep item only if:
      // - It has a term
      // - It's NOT in our SampleProducts list
      // - It does NOT start with "http"
      return (
        term !== "" && 
        !sampleProductNames.has(term) && 
        !term.startsWith("http")
      );
    });

    setHistoryDetails(filteredSearches);
  } catch (err) {
    console.error("❌ History details fetch error", err);
  }
};*/


  /* ===============================
     Fetch Admin Data
  ================================ */
  const fetchData = async (tab) => {
    setLoading(true);
    setData([]);
    setCurrentPage(1);

    const endpoints = {
      users: "/Owner/users",
      students: "/Owner/students",
      consultants: "/Owner/consultant-bookings",
      orders: "/Owner/orders",
      mindmap: "/Owner/mind-mapping",
      ideaValidation: "/Owner/idea-validation",
      admin: "/Owner/info",
      history: "/Owner/search-history/summary"
    };
    

    try {
      const res = await fetch(`${BASE_URL}${endpoints[tab]}`);
      const json = await res.json();

      const keyMap = {
        users: json.users,
        consultants: json.bookings,
        orders: json.orders,
        mindmap: json.responses,
        ideaValidation: json.forms,
        admin: json.users,
        students: json.students,
        history: json.data,
      };

      setData(keyMap[tab] || []);
      if (tab === "history") {
  setHistorySummary(json.data || []);
  setHistoryDetails([]);
  setSelectedHistoryUser(null);
}

    } catch (err) {
      console.error("❌ Admin fetch error:", err);
    } finally {
      setLoading(false);
    }
  };


  const searchSuggestions = useMemo(() => {
  if (!search.trim()) return [];

  const query = search.toLowerCase();

  // Collect unique text values from current tab data
  const suggestionsSet = new Set();

  data.forEach((row) => {
    Object.values(row).forEach((val) => {
      if (!val) return;

      const text = String(val);
      if (text.toLowerCase().includes(query)) {
        suggestionsSet.add(text);
      }
    });
  });

  return Array.from(suggestionsSet).slice(0, 20);
}, [search, data]);


  useEffect(() => {
  if (activeTab !== "history") return;
  if (!historySummary.length) return;

  const saved = localStorage.getItem("owner_last_active_history_user");
  if (!saved) return;

  const { user_id, role } = JSON.parse(saved);

  const match = historySummary.find(
    (u) => u.user_id === user_id && u.role === role
  );

if (match) {
  setSelectedHistoryUser(match);
  setHistoryRoleFilter(match.role === "user" ? "users" : "students"); // ✅ ADD
  fetchHistoryDetails(match.user_id, match.role);
}

}, [historySummary, activeTab]);

useEffect(() => {
  if (activeTab !== "history") return;

  const saved = localStorage.getItem("owner_last_active_history_user");
  if (!saved) return;

  const { role } = JSON.parse(saved);

  setHistoryRoleFilter(role === "user" ? "users" : "students");
}, [activeTab]);


  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  /* ===============================
     Search Filter
  ================================ */
  const filteredData = useMemo(() => {
    if (!search) return data;

    const query = search.toLowerCase();

    return data.filter((row) =>
      Object.values(row).some((value) => {
        if (!value) return false;
        return String(value).toLowerCase().includes(query);
      })
    );
  }, [search, data]);

  const filteredHistorySummary = useMemo(() => {
  if (!search) return historySummary;

  const query = search.toLowerCase();

  return historySummary.filter((row) =>
    Object.values(row).some((value) => {
      if (!value) return false;
      return String(value).toLowerCase().includes(query);
    })
  );
}, [search, historySummary]);

const filteredHistoryUsers = useMemo(() => {
  return filteredHistorySummary.filter((row) => {
    const role = row.role?.toLowerCase();

    const matchesRole =
      historyRoleFilter === "users"
        ? role === "user"
        : role === "student";

    const matchesSearch =
      row.user_id.toString().includes(historyUserSearch) ||
      row.name.toLowerCase().includes(historyUserSearch.toLowerCase());

    return matchesRole && matchesSearch;
  });
}, [filteredHistorySummary, historyRoleFilter, historyUserSearch]);

const filteredHistoryDetails = useMemo(() => {
  if (!historyDetails.length) return [];

  const now = new Date();
  let fromDate = null;
  let toDate = null;

  // 🔘 BUTTON FILTERS (relative)
  if (historyDateFilter === "24h") {
    fromDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  }

  if (historyDateFilter === "week") {
    fromDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  }

  if (historyDateFilter === "month") {
    fromDate = new Date(now);
    fromDate.setMonth(fromDate.getMonth() - 1);
  }

  // 📅 DROPDOWN FILTER (EXACT YEAR)
  if (historyYearFilter) {
    fromDate = new Date(`${historyYearFilter}-01-01T00:00:00`);
    toDate = new Date(`${historyYearFilter}-12-31T23:59:59`);
  }

  return historyDetails.filter((row) => {
    if (!row.created_at) return false;

    const created = new Date(row.created_at);

    if (fromDate && toDate) {
      return created >= fromDate && created <= toDate;
    }

    if (fromDate) {
      return created >= fromDate;
    }

    return true;
  });
}, [historyDetails, historyDateFilter, historyYearFilter]);



useEffect(() => {
  if (activeTab === "history") {
    console.log("History roles:", [...new Set(historySummary.map(r => r.role))]);
  }
}, [historySummary, activeTab]);



  /* ===============================
     Stats (Last 24 hrs)
  ================================ */
  const last24HoursCount = useMemo(() => {
    const now = new Date();
    const last24 = new Date(now.getTime() - 24 * 60 * 60 * 1000);

    return data.filter(
      (item) => item.created_at && new Date(item.created_at) >= last24
    ).length;
  }, [data]);

  const historyStats = useMemo(() => {
  let totalSearches = 0;
  let last24HourSearches = 0;

  historySummary.forEach((row) => {
    totalSearches += Number(row.totalSearches || 0);
    last24HourSearches += Number(row.last24HoursSearches || 0);
  });

  return {
    totalSearches,
    last24HourSearches,
  };
}, [historySummary]);


  /* ===============================
     Pagination
  ================================ */
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  const paginatedData = filteredData.slice(startIndex, endIndex);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  /* ===============================
     Logout
  ================================ */
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = `/Owner/login/${process.env.REACT_APP_OWNER_PATH}/en-list/owner`;
  };



  return (
    <div className="owner-panel-wrapper">

      {/* ================= Navbar ================= */}
      <div className="owner-panel-navbar">
        <div className="owner-panel-navbar-title">Owner Dashboard</div>
        <button className="owner-panel-logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* ================= Analytics stat cards ================= */}
      <div style={{ padding: "20px 24px 4px" }}>
        <StatsGrid stats={statCards.length ? statCards : undefined} loading={statsLoading} />
      </div>

      {/* ================= Tabs ================= */}
     <div className="owner-panel-tabs owner-panel-tabs-row">

  {/* LEFT TABS */}
      <div className="owner-panel-tabs-left">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`owner-panel-tab-btn ${
              activeTab === tab.key ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* RIGHT TAB (Admin Info) */}
      <div className="owner-panel-tabs-right">
        <button
          className={`owner-panel-tab-btn ${
            activeTab === adminTab.key ? "active" : ""
          }`}
          onClick={() => setActiveTab(adminTab.key)}
        >
          {adminTab.label}
        </button>
      </div>

      </div>


      {/* ================= Search ================= */}
      <div className="owner-panel-search-wrapper">

        <div
  className={`owner-search-wrapper ${
    search ? "search-active" : ""
  }`}
>
            <input
              type="text"
              className="owner-panel-search"
              placeholder="Search anything..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setShowSuggestions(true);
              }}
              onFocus={() => setShowSuggestions(true)}
            />
            </div>

          {search && (
            <span
              className="owner-search-clear"
              onClick={() => {
                setSearch("");
                setShowSuggestions(false);
              }}
            >
              ✕
            </span>
          )}
        {showSuggestions && searchSuggestions.length > 0 && (
            <div className="owner-search-suggestions">
              {searchSuggestions.map((item, idx) => (
                <div
                  key={idx}
                  className="owner-search-suggestion-item"
                  onMouseDown={() => {
                    setSearch(item);
                    setShowSuggestions(false);
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          )}


      </div>

      {/* ================= Stats ================= */}
       <div className="owner-panel-stats owner-panel-stats-row">
        <div className="owner-panel-stats-left">
          {/* HISTORY TAB STATS */}
          {activeTab === "history" ? (
            <>
              <div className="owner-panel-stat-box">
                <span className="stat-title">Searches (Last 24 hrs)</span>
                <span className="stat-value">
                  {historyStats.last24HourSearches}
                </span>
              </div>

              <div className="owner-panel-stat-box">
                <span className="stat-title">Total Searches</span>
                <span className="stat-value">
                  {historyStats.totalSearches}
                </span>
              </div>
            </>
          ) : (
            <>
              <div className="owner-panel-stat-box">
                <span className="stat-title">New (Last 24 hrs)</span>
                <span className="stat-value">{last24HoursCount}</span>
              </div>

              <div className="owner-panel-stat-box">
                <span className="stat-title">Total</span>
                <span className="stat-value">{data.length}</span>
              </div>
            </>
          )}

        </div>

        {/* ➕ Add Button goes here (Step 2) */}
        <div className="owner-panel-stats-right">
        {activeTab === "users" && (
          <button className="owner-panel-add-btn" onClick={() => setShowAddUserModal(true)}>
            + Add User
          </button>
        )}
        
        {/* NEW BUTTON FOR ADMIN INFO TAB */}
        {activeTab === "admin" && (
          <button className="owner-panel-add-btn" onClick={() => setShowAddAdminModal(true)}>
            + Add Admin
          </button>
        )}
      </div>

      </div>


            {/* ================= Content ================= */}
          {/* ================= Content ================= */}
      <div className="owner-panel-content">

        {/* ========== HISTORY TAB ========== */}
        {activeTab === "history" && (
          <div className="owner-history-layout">

            {/* LEFT TABLE – SUMMARY */}
          <div className="owner-history-left">

        {/* ROLE FILTER BUTTONS */}
        <div className="owner-history-role-toggle">
          <button
            className={historyRoleFilter === "users" ? "active" : ""}
            onClick={() => setHistoryRoleFilter("users")}
          >
            Users
          </button>

          <button
            className={historyRoleFilter === "students" ? "active" : ""}
            onClick={() => setHistoryRoleFilter("students")}
          >
            Students
          </button>
        </div>

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search user or student..."
          className="owner-history-search"
          value={historyUserSearch}
          onChange={(e) => setHistoryUserSearch(e.target.value)}
        />

        {/* USER LIST TABLE */}
        <table className="owner-panel-table owner-history-user-table">
          <thead>
            <tr>
              <th>User ID</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistoryUsers.length === 0 && (
              <tr>
                <td colSpan="2" className="owner-panel-empty">
                  No users found
                </td>
              </tr>
            )}

            {filteredHistoryUsers.map((row) => (
              <tr
                key={row.user_id}
                onClick={() => {
        setSelectedHistoryUser(row);
        fetchHistoryDetails(row.user_id, row.role);

        // ✅ SAVE LAST ACTIVE USER
        localStorage.setItem(
          "owner_last_active_history_user",
          JSON.stringify({
            user_id: row.user_id,
            role: row.role
          })
        );
      }}

                className={
                  selectedHistoryUser?.user_id === row.user_id
                    ? "active-history-user"
                    : ""
                }
              >
                <td>{row.user_id}</td>
                <td>{row.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>


            {/* RIGHT TABLE – DETAILS */}
            <div className="owner-history-right">
                            {/* DATE FILTER CONTROLS */}
              <div className="owner-history-filter-bar">

                {/* QUICK FILTER BUTTONS */}
                <div className="owner-history-role-toggle">
                  <button
                    className={historyDateFilter === "24h" ? "active" : ""}
                    onClick={() => {
                      setHistoryDateFilter("24h");
                      setHistoryYearFilter("");
                    }}
                  >
                    Last 24 hrs
                  </button>

                  <button
                    className={historyDateFilter === "week" ? "active" : ""}
                    onClick={() => {
                      setHistoryDateFilter("week");
                      setHistoryYearFilter("");
                    }}
                  >
                    Last Week
                  </button>

                  <button
                    className={historyDateFilter === "month" ? "active" : ""}
                    onClick={() => {
                      setHistoryDateFilter("month");
                      setHistoryYearFilter("0");
                    }}
                  >
                    Last Month
                  </button>
                  <button
                    className="owner-history-filter-btn"
                    onClick={() => {
                      setHistoryDateFilter("");
                      setHistoryYearFilter("");
                    }}
                  >
                    Clear filters
                  </button>

                </div>

                {/* YEAR DROPDOWN */}
               <select
                className="owner-history-year-dropdown"
                value={historyYearFilter}
                onChange={(e) => {
                  setHistoryYearFilter(e.target.value);
                  setHistoryDateFilter("");
                }}
              >
                <option value="">Select Year</option>
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
              </select>


              </div>

              {!selectedHistoryUser && (
                <p className="owner-panel-empty">
                  Select a user or student to view search history
                </p>
              )}

              {selectedHistoryUser && (
                <table className="owner-panel-table">
                  <thead>
                    <tr>
                      <th>Search Term</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredHistoryDetails.length === 0 && (
                      <tr>
                        <td colSpan="3" className="owner-panel-empty">
                          No searches found
                        </td>
                      </tr>
                    )}

                    {filteredHistoryDetails.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.search_term}</td>
                        <td>{new Date(row.created_at).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

          </div>
        )}

        {/* ========== ALL OTHER TABS ========== */}
        {activeTab !== "history" && (
          <>
            {loading && <p className="owner-panel-loading">Loading...</p>}

            {!loading && paginatedData.length === 0 && (
              <p className="owner-panel-empty">No records found</p>
            )}

            {!loading && paginatedData.length > 0 && (
              <table className="owner-panel-table">
                <thead>
                  <tr>
                    {Object.keys(paginatedData[0]).map((key) => (
                      <th key={key}>{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paginatedData.map((row, idx) => (
                    <tr key={idx}>
                      {Object.values(row).map((val, i) => (
                        <td key={i}>
                          {Array.isArray(val)
                            ? val.join(", ")
                            : typeof val === "object" && val !== null
                            ? JSON.stringify(val)
                            : String(val)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

      </div>

      {/* ================= Pagination ================= */}
      {totalPages > 1 && (
        <div className="owner-panel-pagination-bar">
          <div className="owner-panel-pagination-info">
            {startIndex + 1}–{Math.min(endIndex, totalItems)} of {totalItems}
          </div>

          <div className="owner-panel-pagination-controls">
            {currentPage > 1 && (
              <button onClick={() => goToPage(currentPage - 1)}>&lt;</button>
            )}

            <div className="owner-panel-pagination-current-page">
              {currentPage}
            </div>

            {currentPage < totalPages && (
              <button onClick={() => goToPage(currentPage + 1)}>&gt;</button>
            )}
          </div>
        </div>
      )}

          {showAddUserModal && (
      <OwnerAddUserModal
        onClose={() => setShowAddUserModal(false)}
        onSuccess={() => fetchData("users")}
      />
    )}
    {showAddAdminModal && (
      <OwnerAddAdminModal 
        onClose={() => setShowAddAdminModal(false)} 
        onSuccess={() => fetchData("admin")} 
      />
    )}

        </div>
      );
    }
